import React, { Component } from 'react';
import { IresumeData } from '../../../ResumeData';

interface IresumeState {
  readMore: Boolean;
}

export default class Resume extends Component<IresumeData, IresumeState> {
  constructor(props: IresumeData) {
    super(props);
    this.state = {
      readMore: false,
    };
  }

  setReadMore(readMore: Boolean) {
    this.setState({ readMore: readMore });
  }

  render() {
    let resumeData = this.props.resumeData;
    const shortResume = resumeData.experience.slice(0, 2).map((entry) => {
      return (
        <div className="resume-block">
          <div className="resume-block__header">
            <h4 className="h3">{entry.company}</h4>
            <p className="resume-block__header-meta">
              <span>{entry.position}</span>
              <span className="resume-block__header-date">
                {entry.beginningDate?.toLocaleDateString()} -{' '}
                {entry.endingDate
                  ? entry.endingDate.toLocaleDateString()
                  : 'Present'}
              </span>
              <br />
              <span className="resume-block__about">{entry.aboutCompany}</span>
            </p>
          </div>
          <div style={{ textAlign: 'left' }}>
            {entry.keyPoints?.slice(0, 2).map((work, index) => (
              <li
                style={{
                  paddingBottom: '13px',
                  letterSpacing: '0.10em',
                }}
                key={index}
              >
                {`${work.slice(0, 65)}...`}
              </li>
            ))}
          </div>
          <div style={{ textAlign: 'right' }}>
            Technologies:{' '}
            {entry.technologies
              ? `${entry.technologies.slice(0, 30)}...`
              : 'None so far'}
          </div>
        </div>
      );
    });
    const fullResume = resumeData.experience.map((entry) => {
      return (
        <div className="resume-block">
          <div className="resume-block__header">
            <h4 className="h3">{entry.company}</h4>
            <p className="resume-block__header-meta">
              <span>{entry.position}</span>
              <span className="resume-block__header-date">
                {entry.beginningDate?.toLocaleDateString()} -{' '}
                {entry.endingDate
                  ? entry.endingDate.toLocaleDateString()
                  : 'Present'}
              </span>
              <br />
              <span className="resume-block__about">{entry.aboutCompany}</span>
            </p>
          </div>
          <div style={{ textAlign: 'left' }}>
            {entry.keyPoints?.map((work, index) => (
              <li
                style={{
                  paddingBottom: '13px',
                  letterSpacing: '0.10em',
                }}
                key={index}
              >
                {work}
              </li>
            ))}
          </div>
          <div style={{ textAlign: 'right' }}>
            Technologies: {entry.technologies}
          </div>
        </div>
      );
    });

    return (
      <React.Fragment>
        <section id="resume" className="s-resume target-section">
          <div className="row s-resume__section">
            <div className="column large-3 tab-12">
              <h3 className="section-header-allcaps">Career</h3>
            </div>
            <div className="column large-9 tab-12">
              {!this.state.readMore && shortResume}
              {this.state.readMore && fullResume}
              <a
                href="/#resume"
                className="read-more-link"
                onClick={() => this.setReadMore(!this.state.readMore)}
              >
                {' '}
                <p className="resume-block__header-meta">
                  <span style={{ fontSize: '28px' }}>
                    {this.state.readMore ? 'Read Less << ' : 'Read More >> '}
                  </span>
                </p>{' '}
              </a>
            </div>
          </div>
          <div className="row s-resume__section">
            <div className="column large-3 tab-12">
              <h3 className="section-header-allcaps">Education</h3>
            </div>
            <div className="column large-9 tab-12">
              {resumeData.education.map((entry) => {
                return (
                  <div className="resume-block">
                    <div className="resume-block__header">
                      <h4 className="h3">{entry.school}</h4>
                      <p className="resume-block__header-meta">
                        <span>{entry.degree}</span>
                        <span className="resume-block__header-date">
                          {entry.beginningDate?.toLocaleDateString()} -{' '}
                          {entry.endingDate
                            ? entry.endingDate.toLocaleDateString()
                            : 'Present'}
                        </span>
                        <br />
                        {entry.awards && (
                          <span className="resume-block__about">
                            {entry.awards}
                          </span>
                        )}
                      </p>
                    </div>
                    <div style={{ textAlign: 'left' }}>
                      {entry.keyPoints?.map((education, index) => (
                        <li
                          style={{
                            paddingBottom: '13px',
                            letterSpacing: '0.10em',
                          }}
                          key={index}
                        >
                          {education}
                        </li>
                      ))}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="row s-resume__section">
            <div className="column large-3 tab-12">
              <h3 className="section-header-allcaps">Teaching</h3>
            </div>
            <div className="column large-9 tab-12">
              {resumeData.teaching.map((entry) => {
                return (
                  <div className="resume-block">
                    <div className="resume-block__header">
                      <h4 className="h3">{entry.company}</h4>
                      <p className="resume-block__header-meta">
                        <span>{entry.position}</span>
                        <span className="resume-block__header-date">
                          {entry.beginningDate?.toLocaleDateString()} -{' '}
                          {entry.endingDate
                            ? entry.endingDate.toLocaleDateString()
                            : 'Present'}
                        </span>
                        <br />
                        <span className="resume-block__about">
                          {entry.aboutCompany}
                        </span>
                      </p>
                    </div>
                    <div style={{ textAlign: 'left' }}>
                      {entry.keyPoints?.map((work, index) => (
                        <li
                          style={{
                            paddingBottom: '13px',
                            letterSpacing: '0.10em',
                          }}
                          key={index}
                        >
                          {work}
                        </li>
                      ))}
                    </div>
                    <div style={{ textAlign: 'right' }}>
                      Technologies: {entry.technologies}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="row s-resume__section">
            <div className="column large-3 tab-12">
              <h3 className="section-header-allcaps">Skills</h3>
            </div>
            <div className="column large-9 tab-12">
              <div className="resume-block">
                <p>
                  Here are my self ranked skill level of the technologies I am
                  proficient in
                </p>
                <ul className="skill-bars-fat">
                  <li>
                    <div className="progress percent85" />
                    <strong>Python</strong>
                  </li>
                  <li>
                    <div className="progress percent80" />
                    <strong>Pandas</strong>
                  </li>
                  <li>
                    <div className="progress percent80" />
                    <strong>Typescript</strong>
                  </li>
                  <li>
                    <div className="progress percent65" />
                    <strong>SQL</strong>
                  </li>
                  <li>
                    <div className="progress percent50" />
                    <strong>AWS</strong>
                  </li>
                  <li>
                    <div className="progress percent50" />
                    <strong>C#</strong>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}
